import { Factory } from '../../services/Factory';
import { ProjectService } from '../../services/project/ProjectService';
import { AccountService } from '../../services/account/AccountService';
import { INotificationService } from '../../services/notification';

interface IHibernateControllerScope extends angular.IScope {
  project;
  closeModal: Function;
  startHibernation: Function;
  saving: boolean;
  authyToken: string;
}

export class HibernateModalController {
  private $scope:IHibernateControllerScope;
  private $modalInstance;
  private $location;
  private project;
  private projectService: ProjectService;
  private accountService: AccountService;
  private notificationService: INotificationService;

  constructor($scope:IHibernateControllerScope, $modalInstance, $location, project, projectService: ProjectService, accountService: AccountService, notificationService: INotificationService) {
    this.$scope = $scope;
    this.$modalInstance = $modalInstance;
    this.$location = $location;
    this.project = project;
    this.accountService = accountService;
    this.projectService = projectService;
    this.notificationService = notificationService;

    this.$scope.closeModal = () => {
      this.$modalInstance.close();
    };

    this.$scope.startHibernation = () => {
      this.$scope.saving = true;

      projectService.Hibernate(this.project, this.$scope.authyToken, () => {
        this.$scope.saving = false;
        this.$modalInstance.close();

        this.notificationService.addSuccess({
          title: "Project hibernated successfully",
          description: this.project.name,
          timeout: 5000
        });

        $location.path('/project');

      }, (data) => {
        this.$scope.saving = false;
        this.notificationService.addError({
          title: "Unable to hibernate project",
          description: data,
          timeout: 5000
        });
      })

    };

    this.accountService.StartMFA();
  }
}

frontendApp.controller("HibernateModalController", ["$scope", "$uibModalInstance", "$location", "project", "ProjectService", "AccountService", "NotificationService", Factory.Create(HibernateModalController)]);
